import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { Reveal } from "@/components/motion";

const Counter = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.1 });
  const [n, setN] = useState(580);
  useEffect(() => {
    if (!inView) return undefined;
    const c = animate(120, 580, { duration: 2.2, ease: [0.22, 1, 0.36, 1], onUpdate: (v) => setN(Math.round(v)) });
    return () => c.stop();
  }, [inView]);
  return <span ref={ref} className="gold-text lining-nums tabular-nums" data-testid="stats-count">{n}+</span>;
};

export const StatsBar = () => (
  <section className="border-y border-line bg-ink2 px-5 py-14 sm:px-8 lg:px-12" data-testid="stats-section">
    <Reveal className="wrap flex flex-col gap-6 md:flex-row md:items-center md:gap-14">
      <div className="font-serif text-7xl font-semibold leading-none sm:text-8xl"><Counter /></div>
      <p className="max-w-2xl text-[15px] leading-relaxed text-sand md:text-base">
        <b className="font-semibold text-cream">centri estetici formati in 4 anni</b> con i protocolli Natural Anti-Age Skin Lovers, da Magione a tutta Italia. Prodotti professionali, protocolli proprietari e formazione: un unico metodo.
      </p>
    </Reveal>
  </section>
);

const WORDS = ["Natural Anti-Age", "Estetica rigenerativa", "Senza aghi", "Risultati visibili", "Rispetta la naturalezza", "Metodo Skin Lovers"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w) => (
      <span key={w} className="flex items-center">
        <span className="px-8 font-serif text-4xl italic text-cream/90 sm:text-6xl">{w}</span>
        <span className="text-xl text-gold">✦</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="marquee overflow-hidden border-b border-line py-8 sm:py-10" aria-hidden="true" data-testid="editorial-marquee">
    <div className="marquee-track">
      <Row />
      <Row />
    </div>
  </div>
);
